import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IoMdArrowDroprightCircle,
  IoMdArrowDropleftCircle,
} from 'react-icons/io';

import { CarouselImagesProps } from 'types/CarouselImagesProps';
import { color } from 'styles/colors';
import * as S from './styles';

interface CarouselProps {
  items: CarouselImagesProps[];
  interval?: number;
  isBtns?: boolean;
  isAutoPlay?: boolean;
  isShowQtdBanners?: boolean;
  positionContainerBalls?: 0 | 1;
  objectFitImg?: 'cover' | 'fill' | 'contain';
}

export default function Carousel({
  items,
  interval = 3000,
  isBtns = true,
  isAutoPlay = true,
  isShowQtdBanners = true,
  positionContainerBalls = 0,
  objectFitImg = 'cover',
}: CarouselProps) {
  const { t } = useTranslation();
  const carrosel: any = useRef(null);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);

  function handlePreviousClick() {
    if (currentItemIndex > 0) {
      setCurrentItemIndex(currentItemIndex - 1);
      carrosel.current.scrollLeft -= carrosel.current.offsetWidth;
    }
  }

  const handleNextClick = () => {
    if (currentItemIndex < items.length - 1) {
      setCurrentItemIndex(currentItemIndex + 1);
      carrosel.current.scrollLeft += carrosel.current.offsetWidth;
    } else {
      setCurrentItemIndex(0);
      carrosel.current.scrollLeft = 0; // Volta para o início
    }
  };

  const handleBallClick = (index: number) => {
    setCurrentItemIndex(index);
    carrosel.current.scrollLeft = carrosel.current.offsetWidth * index;
  };

  useEffect(() => {
    if (isAutoPlay) {
      const intervalId = setInterval(() => {
        handleNextClick();
      }, interval);
      return () => clearInterval(intervalId);
    }
  }, [currentItemIndex, isAutoPlay, interval]);

  return (
    <S.container>
      {items.length > 0 ? (
        <>
          <S.CarouselContainer ref={carrosel} data-testid="containerImages">
            {items.map(item => (
              <S.CarouselItem key={item.id}>
                <S.imageTag objectFitImg={objectFitImg}>
                  <img src={item.imageUrl} alt="imagem" />
                </S.imageTag>
              </S.CarouselItem>
            ))}
          </S.CarouselContainer>

          {isBtns && (
            <div>
              <S.ButtonLeft data-testid="backBtn" onClick={handlePreviousClick}>
                <IoMdArrowDropleftCircle />
              </S.ButtonLeft>

              <S.ButtonRight data-testid="nextBtn" onClick={handleNextClick}>
                <IoMdArrowDroprightCircle />
              </S.ButtonRight>
            </div>
          )}
          {isShowQtdBanners &&
            (positionContainerBalls === 0 ? (
              <S.containerBallsOutsideCarousel data-testid="balls0">
                {items.map((item, i) => (
                  <S.ball
                    checked={color.interface.darkgray2}
                    noChecked={color.interface.white}
                    key={item.id}
                    selected={i === currentItemIndex}
                    onClick={() => handleBallClick(i)} // Você pode manter aqui por enquanto
                  />
                ))}
              </S.containerBallsOutsideCarousel>
            ) : (
              <S.containerBallsInsideCarousel data-testid="balls1">
                {items.map((item, i) => (
                  <S.ball
                    checked={color.interface.greenSuperXtra}
                    noChecked={color.interface.darkgray2}
                    key={item.id}
                    selected={i === currentItemIndex}
                    onClick={() => handleBallClick(i)} // Você pode manter aqui por enquanto
                  />
                ))}
              </S.containerBallsInsideCarousel>
            ))}
        </>
      ) : (
        <S.centralizeNotice>
          <p>{t('bannersCarousel.thereIsNotBanners')}</p>
        </S.centralizeNotice>
      )}
    </S.container>
  );
}
